import { z } from 'zod';

import { BlankTeamValueVisibility, JobHistoryStatus } from '@/common/graphql';

export const TeamJobHistoryFilter = z.object({
  statuses: z.array(z.nativeEnum(JobHistoryStatus)).catch([]),
  countryId: z.string().catch(''),
  businessUnitIds: z.array(z.string()).catch([]),
  departmentIds: z.array(z.string()).catch([]),
  jobIds: z.array(z.string()).catch([]),
  // Carried forward from the Team review screen's own selection on arrival (research.md #33,
  // FR-078 revised) - fixed on this screen, not independently adjustable here (a same-day #34
  // attempt to add a visible control was reverted by research.md #35), same as `countryId`. Still
  // sent to the backend via `filter.blankVisibility` and restored to the Team review screen on
  // `onBack` (research.md #34's bug fix, kept as-is by #35).
  // Defaults to HIDE_PAST (research.md #34) only as a graceful fallback for a URL that predates
  // this field, since it is always explicitly carried over in normal navigation.
  blankVisibility: z.nativeEnum(BlankTeamValueVisibility).catch(BlankTeamValueVisibility.HidePast),
});

export type TeamJobHistoryFilterType = z.infer<typeof TeamJobHistoryFilter>;
